import { useAppDispatch } from "@/store/hooks";
import { updateSlide } from "@/store/slideEditorSlice";
import type { SlideFields } from "@/types/Slide";
import type { HandWritingSlideData } from "@ai-teach/types";
import type { MediaInput, SlideHandlers } from "../types";

const EMPTY_AUDIO = { src: null, id: null, filename: null };

export const useHandWritingHandlers = (slide: SlideFields | null): SlideHandlers => {
  const dispatch = useAppDispatch();

  const slideId = slide?.id;
  const slideData = slide?.slideData as HandWritingSlideData | undefined;

  /** `wordIndex` is the position in `text` the clip belongs to — audio is per word, not per slide. */
  const addAudio = ({ id, src, filename }: MediaInput, wordIndex: string | undefined) => {
    if (!slideId || !slideData) return;

    const index = Number(wordIndex);
    if (!Number.isInteger(index) || index < 0 || index >= slideData.text.length) {
      throw new Error("Drag audio onto one of the words!");
    }

    const textAudios = slideData.text.map(
      (_, at) => (at === index ? { src, id, filename } : slideData.textAudios?.[at]) ?? EMPTY_AUDIO
    );

    dispatch(updateSlide({ slideId, slideData: { ...slideData, textAudios } }));
  };

  return {
    addAudio,
  };
};
